import InputCaptcha from "./components/InputCaptcha.vue";

import { nextId } from "./composables/common.js";
import { useUserStore } from "./store/auth.js";

const components = {
    InputCaptcha
};

export default {
    install: (app) => {
        for (const name in components) {
            app.component(name, components[name]);
        }
    },
    nextId,
	useUserStore
};
